/**
 * 8-character code input rendered as two groups of four "inventory slots".
 * A single real <input> sits on top (accessible, paste-friendly); the slots only mirror it.
 */
import { useRef, useState } from 'react';
import { normalizeLinkCode } from '../api/rest';

export function CodeInput({
  value,
  onChange,
  onComplete,
  disabled,
  invalid,
}: {
  value: string;
  onChange: (normalized: string) => void;
  onComplete?: (normalized: string) => void;
  disabled?: boolean;
  invalid?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);
  const chars = value.padEnd(8, ' ').slice(0, 8).split('');
  const display = value.length > 4 ? `${value.slice(0, 4)}-${value.slice(4)}` : value;

  return (
    <div
      className={`code-input${focused ? ' is-focused' : ''}${invalid ? ' is-invalid' : ''}${disabled ? ' is-disabled' : ''}`}
      onClick={() => ref.current?.focus()}
    >
      <div className="slots" aria-hidden>
        {chars.map((c, i) => (
          <span
            key={i}
            className={`slot${c.trim() ? ' filled' : ''}${focused && i === Math.min(value.length, 7) ? ' caret' : ''}${i === 4 ? ' gap' : ''}`}
          >
            {c.trim()}
          </span>
        ))}
      </div>
      <input
        ref={ref}
        className="code-input-real"
        data-testid="link-code-input"
        inputMode="text"
        autoComplete="one-time-code"
        autoCapitalize="characters"
        autoCorrect="off"
        spellCheck={false}
        aria-label="Codice di collegamento di 8 caratteri"
        aria-invalid={invalid || undefined}
        maxLength={12}
        disabled={disabled}
        value={display}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => {
          const n = normalizeLinkCode(e.target.value).slice(0, 8);
          onChange(n);
          if (n.length === 8 && n !== value) onComplete?.(n);
        }}
      />
    </div>
  );
}
